import { followUpState } from "../components/admin/FollowUpBadge";

const STALE_NEW_MS = 24 * 60 * 60 * 1000;

// Mirrors backend/digest.py: overdue / due today follow-ups, or New leads untouched for >24h.
export const followUpReason = (lead) => {
  if (lead.status === "Closed") return null;
  const state = followUpState(lead.follow_up_at);
  if (state === "overdue" || state === "today") return state;
  if (lead.status === "New" && Date.now() - new Date(lead.created_at).getTime() > STALE_NEW_MS) return "waiting";
  return null;
};

const RANK = { overdue: 0, today: 1, waiting: 2 };

export const sortByUrgency = (leads) =>
  [...leads].sort((a, b) => {
    const ra = RANK[followUpReason(a)] ?? 9, rb = RANK[followUpReason(b)] ?? 9;
    if (ra !== rb) return ra - rb;
    if (a.follow_up_at && b.follow_up_at && a.follow_up_at !== b.follow_up_at) return a.follow_up_at < b.follow_up_at ? -1 : 1;
    return a.created_at < b.created_at ? -1 : 1;
  });
